// extracted by css-extract-rspack-plugin
export default {"cls1":"TasteOfMentionsUpsellModal-cls1_eUK","cls2":"TasteOfMentionsUpsellModal-cls2_DIw TasteOfMentionsUpsellModal-cls1_eUK"};